import { FareFilterApplicability } from "components/Fare/FareFilter.Applicability";
import { useState, useCallback, useEffect } from "react";
import { AvailableFareModel } from "WebApiClient";

type Props = {
    fareData: AvailableFareModel;
    applicability?: FareFilterApplicability;
    selectedConnections?: number[];
    selectConnection?: (legIndex: number, connectionIndex: number) => void;
};

export const useFareManager = ({
    fareData,
    applicability,
    selectedConnections,
    selectConnection,
}: Props) => {
    const [internalSelectedConnections, setInternalSelectedConnections] = useState<number[]>([]);
    const [showFlightTimes, setShowFlightTimes] = useState(false);

    // Select or update connection
    const SetSelectedConnection = useCallback((legIndex: number, connectionIndex: number) => {
        if (selectedConnections === undefined) {
            setInternalSelectedConnections((prev) => {
                const updated = [...prev];
                updated[legIndex] = connectionIndex;
                return updated;
            });
        } else if (selectConnection) {
            selectConnection(legIndex, connectionIndex);
        }
    }, [selectedConnections, selectConnection]);

    // Get selected index for a leg
    const GetSelectedConnectionIndexByLegIndex = (legIndex: number): number =>
        selectedConnections === undefined
            ? internalSelectedConnections[legIndex]
            : selectedConnections[legIndex];

    // Sync selected connections initially
    useEffect(() => {
        if (internalSelectedConnections.length === 0) {
            const initialSelection = fareData.legs.map(() => 0);
            setInternalSelectedConnections(initialSelection);
            return;
        }

        internalSelectedConnections.forEach((val, index) => {
            const applicable = applicability?.ApplicableConnections?.[index];
            if (applicable && !applicable.includes(val)) {
                SetSelectedConnection(index, applicable[0]);
            }
        });
    }, [fareData.legs.length, applicability?.ApplicableConnections, internalSelectedConnections]);

    const ToggleFlightTimes = useCallback(() => {
        setShowFlightTimes(prev => !prev);
    }, []);

    return {
        internalSelectedConnections,
        setInternalSelectedConnections,
        SetSelectedConnection,
        GetSelectedConnectionIndexByLegIndex,
        showFlightTimes,
        ToggleFlightTimes,
        setShowFlightTimes
    };
};
